import { useState, useEffect } from "react";
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAlert from "components/MDAlert";

// Material Dashboard 2 React example components
import DashboardLayout from "core/LayoutContainers/DashboardLayout";
import DashboardNavbar from "core/Navbars/DashboardNavbar";
import Footer from "core/Footer";
import DataTable from "core/Tables/DataTable";

// Services
import AdminService from "../../services/admin-service";

const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await AdminService.getUsers();
        setUsers(response.users);
      } catch (err) {
        setError("Failed to fetch users. Please try again later.");
        console.error(err);
      }
    };

    fetchUsers();
  }, []);

  const handleToggle = async (userId, currentStatus) => {
    try {
      await AdminService.toggleUserEnabled(userId, !currentStatus);
      // Update the local state to reflect the change
      setUsers(prevUsers => 
        prevUsers.map(user => 
          user.id === userId 
            ? { ...user, enabled: !currentStatus } 
            : user
        )
      );
    } catch (err) {
      setError("Failed to update user status. Please try again later.");
      console.error(err);
    }
  };

  const columns = [
    { Header: "Name", accessor: "name", width: "25%", align: "left" },
    { Header: "Email", accessor: "email", align: "left" },
    { Header: "Created On", accessor: "createdOn", align: "center" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Actions", accessor: "action", align: "center" },
  ];

  const rows = users.map((user) => ({
    name: `${user.firstName} ${user.lastName}`,
    email: user.email,
    createdOn: new Date(user.createdOn).toLocaleDateString(),
    status: (
      <MDBox>
        <MDTypography 
          variant="caption" 
          fontWeight="medium" 
          color={user.enabled ? "success" : "error"}
        >
          {user.enabled ? "Active" : "Disabled"}
        </MDTypography>
      </MDBox>
    ),
    action: (
      <MDBox display="flex" justifyContent="center">
        <Switch
          checked={user.enabled}
          onChange={() => handleToggle(user.id, user.enabled)}
          sx={{
            '& .MuiSwitch-switchBase.Mui-checked': {
              color: '#4CAF50',
            },
            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
              backgroundColor: '#4CAF50',
            },
          }}
        />
      </MDBox>
    ),
  }));

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  User Management
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                {error && (
                  <MDAlert color="error" dismissible>
                    {error}
                  </MDAlert>
                )}
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default UserManagement;